import { canvasFontStack, snapSurfFontWeight } from "../style/surfFonts.js";
export const SURF_SLIDE_ASPECT = 16 / 9;
export function surfSlideWidthPx(slideHeightPx) {
    return slideHeightPx * SURF_SLIDE_ASPECT;
}
export function normRectWidthPx(rectW, slideHeightPx) {
    return rectW * surfSlideWidthPx(slideHeightPx);
}
/** Headless fallback when canvas FontFace is unavailable (autofit, unit tests). */
export const approxTextMeasurer = (text, _fontFamily, fontWeight, fontSizePx) => {
    const avg = fontSizePx * (fontWeight >= 700 ? 0.58 : 0.52);
    return text.length * avg;
};
export function wrapTextToLines(text, maxWidthPx, measurer, fontFamily, fontWeight, fontSizePx, opts) {
    if (maxWidthPx <= 0 || !text)
        return [""];
    const paragraphs = text.split("\n");
    const lines = [];
    for (const para of paragraphs) {
        if (!para.trim()) {
            lines.push("");
            continue;
        }
        const words = para.split(/\s+/).filter(Boolean);
        let current = "";
        for (const word of words) {
            const candidate = current ? `${current} ${word}` : word;
            const width = measurer(candidate, fontFamily, fontWeight, fontSizePx);
            if (width <= maxWidthPx || !current) {
                current = candidate;
            }
            else {
                lines.push(current);
                current = word;
            }
        }
        if (current) {
            lines.push(current);
        }
    }
    return lines.length ? lines : [""];
}
export function layoutTextBlock(text, maxWidthPx, measurer, fontFamily, fontWeight, fontSizePx, lineHeight, opts) {
    const lines = wrapTextToLines(text, maxWidthPx, measurer, fontFamily, fontWeight, fontSizePx, opts);
    return { lines, heightPx: lines.length * fontSizePx * lineHeight };
}
export const DEFAULT_SLIDE_HEIGHT_PX = 540;
export function defaultTextLayoutContext() {
    return { measurer: approxTextMeasurer, slideHeightPx: DEFAULT_SLIDE_HEIGHT_PX };
}
/** Build canvas font CSS string for measureText (browser). */
export function canvasMeasureFont(fontFamily, fontWeight, fontSizePx) {
    const stack = canvasFontStack(fontFamily);
    const w = snapSurfFontWeight(fontFamily, fontWeight);
    return `${w} ${fontSizePx}px ${stack}`;
}
